import { render, staticRenderFns } from "./Candle.vue?vue&type=template&id=82369e3c&scoped=true&"
var script = {}
import style0 from "./Candle.vue?vue&type=style&index=0&id=82369e3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82369e3c",
  null
  
)

export default component.exports